import { css } from "styled-components";

export const markdownStyles = css`
  .markdown-content {
    ol,
    ul {
      display: block;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: ${props => props.theme.sizes.xl};
      font-family: ${(props) => props.theme.fonts.families.fontAbbLight};
    }
    ul {
      list-style-type: disc;
    }
    ol {
      list-style-type: decimal;
    }
  }
`;
